const ROLE_TYPE_LIST = {
	ADMIN: { code: "1", label: "common.typeList.role.admin" },
	CUSTOM: { code: "2", label: "common.typeList.role.client" }
}

export default ROLE_TYPE_LIST
